
import MultipleSelectResponseQuestion from './MultipleSelectResponseQuestion'
import SingleSelectResponseQuestion from './SingleSelectResponseQuestion'
import TextAreaResponseQuestion from './TextAreaResponseQuestion'

export default function ResponsesSection({ question, setAnswer }) {
  switch (question.type) {
    case 'CHECKBOX':
      return (
        <MultipleSelectResponseQuestion
          setAnswer={setAnswer}
          question={question}
        />
      )
    case 'RADIO':
      return (
        <SingleSelectResponseQuestion
          setAnswer={setAnswer}
          question={question}
        />
      )
    case 'TEXT_AREA':
      return <TextAreaResponseQuestion setAnswer={setAnswer} question={question} />
   
    default:
      break
  }
}
